/**
 * `<input type="datetime-local">` speaks the browser's local time without an offset; the API
 * speaks ISO instants. Conversions in one place.
 */
const pad = (n: number) => String(n).padStart(2, '0');

export function toDateTimeLocal(iso: string | Date = new Date()): string {
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromDateTimeLocal(value: string): string | undefined {
  if (!value) return undefined;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? undefined : d.toISOString();
}
